(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["final-product-hero-section"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const container = document.querySelector('.vivincare-product-container');
  if (!container) return;
  
  // Quantity selector
  const quantityValue = container.querySelector('.js-quantity-value');
  const decreaseBtn = container.querySelector('.js-quantity-decrease');
  const increaseBtn = container.querySelector('.js-quantity-increase');
  let quantity = 1;
  
  if (decreaseBtn && increaseBtn && quantityValue) {
    decreaseBtn.addEventListener('click', function() {
      if (quantity > 1) {
        quantity--;
        quantityValue.textContent = quantity;
      }
    });
    
    increaseBtn.addEventListener('click', function() {
      quantity++;
      quantityValue.textContent = quantity;
    });
  }
  
  // Add to cart functionality
  const addToCartBtn = container.querySelector('.js-add-to-cart');
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function() {
      const productId = this.getAttribute('data-product-id');
      const variantId = this.getAttribute('data-variant-id');
      
      // Show loading state
      this.textContent = 'Adding...';
      
      // Add to cart using Shopify AJAX API
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: quantity
        })
      })
      .then(response => response.json())
      .then(data => {
        addToCartBtn.textContent = 'Added!';
        
        // Update cart count (assuming cart.item_count is used in the header)
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const cartCountBtn = container.querySelector('.vivincare-header-controls .vivincare-circle-button');
            if (cartCountBtn) {
              cartCountBtn.textContent = cart.item_count;
            }
          });
          
        setTimeout(() => {
          addToCartBtn.textContent = 'Add to cart';
        }, 2000);
      })
      .catch(error => {
        console.error('Error:', error);
        addToCartBtn.textContent = 'Error';
        setTimeout(() => {
          addToCartBtn.textContent = 'Add to cart';
        }, 2000);
      });
    });
  }
  
  // Product details expansion
  const expandDetailsBtn = container.querySelector('.js-expand-details');
  const productDetails = container.querySelector('.js-product-details');
  const closeDetailsBtn = container.querySelector('.js-close-details');
  
  if (expandDetailsBtn && productDetails && closeDetailsBtn) {
    expandDetailsBtn.addEventListener('click', function() {
      productDetails.classList.add('active');
    });
    
    closeDetailsBtn.addEventListener('click', function() {
      productDetails.classList.remove('active');
    });
  }
  
  // Share functionality
  const shareBtn = container.querySelector('.js-share-button');
  if (shareBtn) {
    shareBtn.addEventListener('click', function() {
      const url = this.getAttribute('data-url');
      
      if (navigator.share) {
        navigator.share({
          title: document.title,
          url: url
        })
        .catch(error => console.error('Error sharing:', error));
      } else {
        // Fallback - copy to clipboard
        navigator.clipboard.writeText(url)
          .then(() => {
            const originalText = shareBtn.textContent;
            shareBtn.textContent = '✓';
            setTimeout(() => {
              shareBtn.textContent = originalText;
            }, 2000);
          })
          .catch(error => console.error('Error copying to clipboard:', error));
      }
    });
  }
  
  // Wishlist functionality
  const wishlistBtn = container.querySelector('.js-wishlist-button');
  if (wishlistBtn) {
    wishlistBtn.addEventListener('click', function() {
      this.classList.toggle('active');
      if (this.classList.contains('active')) {
        this.style.backgroundColor = '#ff6b6b';
      } else {
        this.style.backgroundColor = 'var(--button-color)';
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  // Sticky Header functionality
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.isHomepage = document.body.classList.contains('template-index') || window.location.pathname === '/' || window.location.pathname === '/index';
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });

      // Apply homepage-specific behavior
      if (this.isHomepage) {
        this.setupLandingPageHeader();
      }

      this.createObserver();
      this.setupMenuDrawer();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.isHomepage) {
        window.removeEventListener('scroll', this.checkHeaderTransparency);
      }
    }

    setupLandingPageHeader() {
      // Set up transparent header for landing page
      const headerWrapper = document.querySelector('.header-wrapper');
      if (headerWrapper) {
        headerWrapper.classList.add('transparent-header');
        
        // Hide logo in hero section
        const logo = document.querySelector('.header__heading-logo-wrapper');
        if (logo) {
          logo.style.opacity = '0';
          logo.style.visibility = 'hidden';
        }
        
        // Add scroll event listener for transparency
        this.checkHeaderTransparency = this.handleHeaderTransparency.bind(this);
        window.addEventListener('scroll', this.checkHeaderTransparency, { passive: true });
        // Initial check
        this.handleHeaderTransparency();
      }
    }
    
    // Handle header transparency on scroll for landing page
    handleHeaderTransparency() {
      if (!this.isHomepage) return;
      
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const viewportHeight = window.innerHeight;
      const headerWrapper = document.querySelector('.header-wrapper');
      const logo = document.querySelector('.header__heading-logo-wrapper');
      
      if (scrollTop > viewportHeight) {
        // After 100vh, set to normal and fixed
        headerWrapper.classList.remove('transparent-header');
        headerWrapper.classList.add('after-scroll-header');
        
        // Show logo after scrolling
        if (logo) {
          logo.style.opacity = '1';
          logo.style.visibility = 'visible';
        }
      } else {
        // In hero section, transparent and absolute
        headerWrapper.classList.add('transparent-header');
        headerWrapper.classList.remove('after-scroll-header');
        
        // Hide logo in hero
        if (logo) {
          logo.style.opacity = '0';
          logo.style.visibility = 'hidden';
        }
      }
    }

    // Set up menu drawer with close button and overlay
    setupMenuDrawer() {
      const menuDrawer = document.querySelector('.menu-drawer');
      const menuDrawerContainer = document.querySelector('details.menu-drawer-container');
      const overlay = document.querySelector('.menu-overlay');
      
      // Function to properly restore scrolling
      const restoreScroll = () => {
        // Reset body overflow
        document.body.style.overflow = '';
        document.body.style.position = '';
        document.body.style.width = '';
        document.body.style.height = '';
        document.body.style.top = '';
        document.documentElement.style.overflow = '';
        
        // Remove any classes that might block scrolling
        document.body.classList.remove('overflow-hidden');
        document.body.classList.remove('scroll-lock');
        document.documentElement.classList.remove('overflow-hidden');
        
        // Fix for summary::before pseudo-element
        const summary = menuDrawerContainer ? menuDrawerContainer.querySelector('summary') : null;
        if (summary) {
          summary.style.setProperty('pointer-events', 'none', 'important');
          summary.style.setProperty('position', 'static', 'important');
          
          // Re-enable after a short delay
          setTimeout(() => {
            summary.style.removeProperty('pointer-events');
          }, 100);
        }
        
        // Force scroll to be enabled
        setTimeout(() => {
          document.body.style.overflow = 'auto';
          window.scrollTo(window.scrollX, window.scrollY + 1);
          window.scrollTo(window.scrollX, window.scrollY - 1);
        }, 10);
      };
      
      // Add close button if it doesn't exist
      if (menuDrawer && !menuDrawer.querySelector('.menu-drawer-close')) {
        const closeButton = document.createElement('button');
        closeButton.className = 'menu-drawer-close';
        closeButton.setAttribute('aria-label', 'Close menu');
        menuDrawer.appendChild(closeButton);
        
        // Add click handler for close button
        closeButton.addEventListener('click', function(e) {
          e.preventDefault();
          if (menuDrawerContainer && menuDrawerContainer.hasAttribute('open')) {
            menuDrawerContainer.removeAttribute('open');
            if (overlay) overlay.classList.remove('active');
            restoreScroll();
          }
        });
      }
      
      // Add overlay click handler
      if (overlay) {
        overlay.addEventListener('click', function() {
          if (menuDrawerContainer && menuDrawerContainer.hasAttribute('open')) {
            menuDrawerContainer.removeAttribute('open');
            overlay.classList.remove('active');
            restoreScroll();
          }
        });
      }
      
      // Add toggle menu functionality
      if (menuDrawerContainer) {
        const summary = menuDrawerContainer.querySelector('summary');
        if (summary) {
          summary.addEventListener('click', function(e) {
            // This runs after the default toggle behavior
            setTimeout(() => {
              if (menuDrawerContainer.hasAttribute('open')) {
                // Menu is open
                if (overlay) overlay.classList.add('active');
                document.body.style.overflow = 'hidden';
              } else {
                // Menu is closed
                if (overlay) overlay.classList.remove('active');
                restoreScroll();
              }
            }, 10);
          });
        }
      }
      
      // Close menu with escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && menuDrawerContainer && menuDrawerContainer.hasAttribute('open')) {
          menuDrawerContainer.removeAttribute('open');
          if (overlay) overlay.classList.remove('active');
          restoreScroll();
        }
      });
      
      // Fix for the invisible div near hamburger icon
      document.addEventListener('click', function(e) {
        // Check if menu is closed but something is blocking clicks
        if (menuDrawerContainer && !menuDrawerContainer.hasAttribute('open')) {
          const hamburgerButton = document.querySelector('.header__icon--menu');
          
          // If click is near the hamburger area and not on the hamburger itself
          if (hamburgerButton && !hamburgerButton.contains(e.target)) {
            // Force restore scroll state
            restoreScroll();
            
            // Fix any invisible elements
            const summaries = document.querySelectorAll('summary');
            summaries.forEach(sum => {
              sum.style.setProperty('pointer-events', 'auto', 'important');
            });
          }
        }
      });
      
      // Add a mutation observer to detect when details is closed
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'open') {
            if (!menuDrawerContainer.hasAttribute('open')) {
              // Menu was closed - ensure scroll is restored
              restoreScroll();
            }
          }
        });
      });
      
      if (menuDrawerContainer) {
        observer.observe(menuDrawerContainer, { attributes: true });
      }
      
      // Apply an initial fix on page load
      setTimeout(restoreScroll, 500);
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Only use Shopify's default behavior for non-landing pages
      if (!this.isHomepage) {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

        if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (this.preventHide) return;
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          this.header.classList.remove('scrolled-past-header');
          requestAnimationFrame(this.reset.bind(this));
        }

        this.currentScrollTop = scrollTop;
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Slide-in Cart JavaScript
  document.addEventListener('DOMContentLoaded', function() {
    // Constants for free shipping and minimum order
    const FREE_SHIPPING_THRESHOLD = 59900; // ₹599 in cents
    const MIN_ORDER_AMOUNT = 29900; // ₹299 in cents
    
    // Cart elements
    const slideCart = document.getElementById('slide-cart');
    const slideCartOverlay = document.querySelector('.slide-cart__overlay');
    const cartIconBubble = document.getElementById('cart-icon-bubble');
    const slideCartClose = document.querySelector('.slide-cart__close');
    const cartItemsContainer = document.getElementById('cart-items');
    const emptyCartMessage = document.getElementById('empty-cart-message');
    const cartFooter = document.getElementById('cart-footer');
    const minOrderBanner = document.getElementById('min-order-banner');
    const minOrderText = document.getElementById('min-order-text');
    const freeShippingText = document.getElementById('free-shipping-text');
    const couponToggleBtn = document.getElementById('toggleCouponBtn');
    const couponForm = document.getElementById('couponForm');
    const discountField = document.getElementById('discountCode');
    const applyDiscountBtn = document.getElementById('applyDiscount');
    const discountAppliedSection = document.getElementById('discountApplied');
    const discountText = document.getElementById('discountText');
    const discountCodeApplied = document.getElementById('discountCodeApplied');
    const discountAmount = document.getElementById('discountAmount');
    const removeDiscountBtn = document.getElementById('removeDiscount');
    const discountRow = document.getElementById('discountRow');
    const cartDiscount = document.getElementById('cartDiscount');
    const cartTotal = document.getElementById('cartTotal');
    const cartOriginalTotal = document.getElementById('cartOriginalTotal');
    const checkoutButton = document.getElementById('checkoutButton');
    const shippingProgress = document.querySelector('.slide-cart__shipping-text');
    const discountBadgeContainer = document.getElementById('discountBadgeContainer');
    const discountSummary = document.getElementById('discountSummary');
    const discountCodeBadge = document.getElementById('discountCodeBadge');
    const discountBanner = document.getElementById('discountBanner');
    const discountBannerText = document.getElementById('discountBannerText');
    const totalRow = document.getElementById('totalRow');
    const removeDiscountFromSummary = document.getElementById('removeDiscountFromSummary');
    
    // Initialize the cart
    initializeCart();
    
    // Utility function - Format money
    function formatMoney(cents) {
      if (typeof cents === 'string') {
        cents = cents.replace('.', '');
      }
      
      const value = parseInt(cents || 0, 10);
      return '₹' + (value / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }
    
    // Show notification
    function showNotification(message, isError = false) {
      const notification = document.getElementById('cart-notification');
      const notificationText = notification.querySelector('.slide-cart__notification-text');
      
      notificationText.textContent = message;
      
      if (isError) {
        notification.classList.add('error');
      } else {
        notification.classList.remove('error');
      }
      
      notification.classList.add('show');
      
      setTimeout(() => {
        notification.classList.remove('show');
      }, 3000);
    }
    
    // Initialize cart functionality
    function initializeCart() {
      // Add event listeners for cart toggle
      if (cartIconBubble) {
        cartIconBubble.addEventListener('click', function(e) {
          e.preventDefault();
          openCart();
        });
      }
      
      if (slideCartClose) {
        slideCartClose.addEventListener('click', closeCart);
      }
      
      if (slideCartOverlay) {
        slideCartOverlay.addEventListener('click', closeCart);
      }
      
      // Close cart with ESC key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && slideCart.classList.contains('active')) {
          closeCart();
        }
      });
      
      // Toggle coupon form
      if (couponToggleBtn && couponForm) {
        couponToggleBtn.addEventListener('click', function() {
          if (couponForm.style.display === 'none' || !couponForm.style.display) {
            couponForm.style.display = 'flex';
          } else {
            couponForm.style.display = 'none';
          }
        });
      }
      
      // Apply discount
      if (applyDiscountBtn && discountField) {
        applyDiscountBtn.addEventListener('click', applyDiscount);
        
        // Enable/disable button based on input
        discountField.addEventListener('input', function() {
          applyDiscountBtn.disabled = !this.value.trim();
        });
        
        // Apply on Enter key
        discountField.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' && this.value.trim()) {
            e.preventDefault();
            applyDiscount();
          }
        });
      }
      
      // Remove discount buttons
      if (removeDiscountBtn) {
        removeDiscountBtn.addEventListener('click', removeDiscount);
      }
      
      // Add event listener for the inline remove discount button
      const removeDiscountInline = document.getElementById('removeDiscountInline');
      if (removeDiscountInline) {
        removeDiscountInline.addEventListener('click', removeDiscount);
      }
      
      // Add event listener for removing discount from summary
      if (removeDiscountFromSummary) {
        removeDiscountFromSummary.addEventListener('click', removeDiscount);
      }
      
      // Checkout button
      if (checkoutButton) {
        checkoutButton.addEventListener('click', function() {
          // Check minimum order requirement
          getCart().then(cart => {
            if (cart.total_price < MIN_ORDER_AMOUNT) {
              showNotification(`Minimum order amount is ${formatMoney(MIN_ORDER_AMOUNT)}`, true);
              return;
            }
            
            // Show loading state
            this.classList.add('loading');
            
            // Check if user is logged in
            fetch('/account', {
              method: 'GET',
              headers: {
                'Accept': 'text/html'
              }
            })
            .then(response => {
              // If we get a redirect response, user is not logged in
              const isLoggedIn = response.url.indexOf('/account/login') === -1;
              
              if (isLoggedIn) {
                // User is logged in, proceed to checkout
                window.location.href = '/checkout';
              } else {
                // User is not logged in, redirect to login page with checkout redirect
                window.location.href = '/account/login?checkout_url=' + encodeURIComponent('/checkout');
              }
            })
            .catch(error => {
              console.error('Error checking login status:', error);
              // Default to checkout on error
              window.location.href = '/checkout';
              this.classList.remove('loading');
            });
          })
          .catch(error => {
            console.error('Error getting cart:', error);
            this.classList.remove('loading');
          });
        });
      }
      
      // Add custom debug event for discount
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(function() {
          // Load cart on initialization
          loadCart();
        }, 500); // Delay to ensure all elements are loaded
      });
      
      // Load cart on initialization
      loadCart();
    }
    
    // Enhanced - Load cart contents
    function loadCart() {
      getCart().then(cart => {
        console.log('Cart data:', cart);
        
        // Always force check for discounts, and log discount details
        if (cart.total_discounts > 0) {
          console.log('Discount detected:', cart.total_discounts);
          console.log('Discount applications:', cart.discount_applications);
          
          // Force update all discount elements
          forceUpdateDiscountDisplay(cart);
        }
        
        updateCartDisplay(cart);
      }).catch(error => {
        console.error('Error loading cart:', error);
        showNotification('Error loading cart', true);
      });
    }
    
    // Enhanced - Force update discount display
    function forceUpdateDiscountDisplay(cart) {
      if (cart.total_discounts <= 0) return;
      
      console.log('Updating discount display with discount of:', cart.total_discounts);
      
      // Calculate discount percentage
      const discountPercentage = Math.round((cart.total_discounts / cart.original_total_price) * 100);
      
      // Show discount row with animated highlight effect
      if (discountRow) {
        discountRow.style.display = 'flex';
        
        if (cartDiscount) {
          cartDiscount.textContent = '-' + formatMoney(cart.total_discounts);
        }
        
        // Add highlight animation
        discountRow.classList.add('highlight');
        setTimeout(() => {
          discountRow.classList.remove('highlight');
        }, 1500);
      }
      
      // Show discount badge above total with percentage
      if (discountBadgeContainer) {
        discountBadgeContainer.innerHTML = `
          <span class="slide-cart__discount-badge">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#C20552" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
            SAVE ${discountPercentage}%
          </span>
        `;
      }
      
      // Show discount summary above total with discount code
      if (discountSummary) {
        discountSummary.style.display = 'block';
        
        const discountTypeAboveTotal = document.getElementById('discountTypeAboveTotal');
        const discountAmountAboveTotal = document.getElementById('discountAmountAboveTotal');
        const discountSubtitle = document.getElementById('discountSubtitle');
        
        // Get discount type information
        let discountType = 'Discount applied';
        let discountCode = '';
        
        if (cart.discount_applications && cart.discount_applications.length > 0) {
          const discountApp = cart.discount_applications[0];
          discountType = discountApp.title || 'Discount applied';
          discountCode = discountApp.code || discountApp.title || 'DISCOUNT';
          
          // Also update the discount applied section
          if (discountCodeApplied && discountAppliedSection) {
            discountCodeApplied.textContent = discountApp.title;
            discountAppliedSection.style.display = 'flex';
            
            if (discountAmount) {
              discountAmount.textContent = '-' + formatMoney(cart.total_discounts);
            }
          }
          
          // Update the discount code badge
          if (discountCodeBadge) {
            discountCodeBadge.textContent = discountCode;
          }
          
          if (discountSubtitle) {
            discountSubtitle.style.display = 'block';
          }
        }
        
        if (discountTypeAboveTotal) {
          discountTypeAboveTotal.textContent = `${discountType} (${discountPercentage}% OFF)`;
        }
        
        if (discountAmountAboveTotal) {
          discountAmountAboveTotal.textContent = '-' + formatMoney(cart.total_discounts);
        }
      }
      
      // Show original total (crossed out) alongside discounted total
      if (cartOriginalTotal) {
        cartOriginalTotal.textContent = formatMoney(cart.original_total_price);
        cartOriginalTotal.style.display = 'inline-block';
      }
      
      // Show total savings
      const totalSavings = document.getElementById('totalSavings');
      if (totalSavings) {
        totalSavings.textContent = `You saved ${formatMoney(cart.total_discounts)}`;
        totalSavings.style.display = 'block';
      }
      
      // Apply discount styling to total row
      if (totalRow) {
        totalRow.classList.add('has-discount');
        
        // Add discount indicator badge if it doesn't exist
        if (!totalRow.querySelector('.discount-indicator')) {
          const indicatorEl = document.createElement('div');
          indicatorEl.className = 'discount-indicator';
          indicatorEl.innerHTML = `
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
              <polyline points="20 6 9 17 4 12"></polyline>
            </svg>
          `;
          totalRow.appendChild(indicatorEl);
        }
      }
      
      // Show discount banner above checkout button
      if (discountBanner && discountBannerText) {
        discountBanner.style.display = 'flex';
        discountBannerText.innerHTML = `Discount applied! You're saving <strong>${formatMoney(cart.total_discounts)}</strong>`;
      }
      
      // Add discount badges to cart items
      addDiscountBadgesToItems(cart);
    }
    
    // Add discount badges to individual cart items if they have discounts
    function addDiscountBadgesToItems(cart) {
      cart.items.forEach(item => {
        if (item.original_line_price > item.final_line_price) {
          const discountAmount = item.original_line_price - item.final_line_price;
          const discountPercentage = Math.round((discountAmount / item.original_line_price) * 100);
          
          const itemElement = document.querySelector(`.slide-cart__item[data-key="${item.key}"]`);
          if (itemElement) {
            const priceContainer = itemElement.querySelector('.slide-cart__item-price');
            if (priceContainer && !priceContainer.querySelector('.slide-cart__item-discount-badge')) {
              const badge = document.createElement('div');
              badge.className = 'slide-cart__item-discount-badge';
              badge.textContent = `${discountPercentage}% OFF`;
              priceContainer.appendChild(badge);
            }
          }
        }
      });
    }
    
    // Get cart data
    function getCart() {
      return fetch('/cart.js')
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        });
    }
    
    // Open cart
    function openCart() {
      // Clear any previous loading states
      if (checkoutButton) {
        checkoutButton.classList.remove('loading');
      }
      
      // Refresh cart contents
      loadCart();
      
      // Show cart
      slideCart.classList.add('active');
      slideCartOverlay.classList.add('active');
      document.body.style.overflow = 'hidden'; // Prevent scrolling
    }
    
    // Close cart
    function closeCart() {
      slideCart.classList.remove('active');
      slideCartOverlay.classList.remove('active');
      document.body.style.overflow = ''; // Restore scrolling
    }
    
    // Update cart item
    function updateCartItem(key, quantity) {
      const data = {
        id: key,
        quantity: quantity
      };
      
      // Find the cart item element
      const cartItem = document.querySelector(`.slide-cart__item[data-key="${key}"]`);
      
      // If removing item, animate it
      if (quantity === 0 && cartItem) {
        cartItem.classList.add('removing');
      }
      
      // Show loading state
      slideCart.classList.add('loading');
      
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(cart => {
        updateCartDisplay(cart);
        
        // Show notification
        if (quantity === 0) {
          showNotification('Item removed from cart');
        } else {
          showNotification('Cart updated');
        }
        
        // Update cart count in header
        updateCartCount(cart.item_count);
        
        slideCart.classList.remove('loading');
      })
      .catch(error => {
        console.error('Error updating cart:', error);
        showNotification('Error updating cart', true);
        slideCart.classList.remove('loading');
        
        // Reload cart to ensure consistent state
        loadCart();
      });
    }
    
    // Enhanced - Apply discount
    function applyDiscount() {
      const code = discountField.value.trim();
      
      if (!code) {
        showNotification('Please enter a discount code', true);
        return;
      }
      
      // Show loading state
      applyDiscountBtn.disabled = true;
      applyDiscountBtn.classList.add('loading');
      
      // Use fetch API to apply discount directly
      fetch('/discount/' + encodeURIComponent(code), {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(response => {
        // Get updated cart data
        return getCart();
      })
      .then(cart => {
        applyDiscountBtn.disabled = false;
        applyDiscountBtn.classList.remove('loading');
        
        console.log('Cart after applying discount:', cart);
        
        // Update cart display
        updateCartDisplay(cart);
        
        // Show success notification if discount is applied
        if (cart.total_discounts > 0) {
          showNotification('Discount code applied successfully!');
          
          // Hide coupon form
          couponForm.style.display = 'none';
          
          // Update UI with discount information
          updateDiscountUI(cart, code);
        } else {
          showNotification('Invalid discount code', true);
        }
      })
      .catch(error => {
        console.error('Error applying discount:', error);
        applyDiscountBtn.disabled = false;
        applyDiscountBtn.classList.remove('loading');
        showNotification('Error applying discount', true);
      });
    }
    
    // Update UI when discount is applied
    function updateDiscountUI(cart, code) {
      // Get discount information
      const discountAmount = cart.total_discounts;
      const discountPercentage = Math.round((discountAmount / cart.original_total_price) * 100);
      
      // Update discount code badge
      if (discountCodeBadge) {
        discountCodeBadge.textContent = code.toUpperCase();
      }
      
      // Update discount code in the applied section
      if (discountCodeApplied) {
        discountCodeApplied.textContent = code.toUpperCase();
      }
      
      // Show the discount applied section
      if (discountAppliedSection) {
        discountAppliedSection.style.display = 'flex';
      }
      
      // Update discount amount
      if (discountAmount) {
        discountAmount.textContent = '-' + formatMoney(cart.total_discounts);
      }
      
      // Force update all discount displays
      forceUpdateDiscountDisplay(cart);
    }
    
    // Remove discount
    function removeDiscount() {
      // Show loading state
      if (removeDiscountBtn) {
        removeDiscountBtn.disabled = true;
      }
      
      // Disable all remove discount buttons
      const removeButtons = document.querySelectorAll('.slide-cart__remove-discount, .slide-cart__remove-discount-inline');
      removeButtons.forEach(button => {
        button.disabled = true;
      });
      
      slideCart.classList.add('loading');
      
      fetch('/discount/clear', {
        method: 'GET',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      })
      .then(() => {
        // Get updated cart data
        return getCart();
      })
      .then(cart => {
        // Update cart display
        updateCartDisplay(cart);
        showNotification('Discount removed');
        
        // Reset all discount-related elements
        resetDiscountUI();
        
        slideCart.classList.remove('loading');
      })
      .catch(error => {
        console.error('Error removing discount:', error);
        showNotification('Error removing discount', true);
        
        // Re-enable all remove buttons
        removeButtons.forEach(button => {
          button.disabled = false;
        });
        
        slideCart.classList.remove('loading');
      });
    }
    
    // Reset discount UI elements
    function resetDiscountUI() {
      // Hide discount applied section
      if (discountAppliedSection) {
        discountAppliedSection.style.display = 'none';
      }
      
      // Hide discount row
      if (discountRow) {
        discountRow.style.display = 'none';
      }
      
      // Clear discount badge container
      if (discountBadgeContainer) {
        discountBadgeContainer.innerHTML = '';
      }
      
      // Hide original total
      if (cartOriginalTotal) {
        cartOriginalTotal.style.display = 'none';
      }
      
      // Hide discount summary
      if (discountSummary) {
        discountSummary.style.display = 'none';
      }
      
      // Hide discount banner
      if (discountBanner) {
        discountBanner.style.display = 'none';
      }
      
      // Reset total row styling
      if (totalRow) {
        totalRow.classList.remove('has-discount');
        const indicator = totalRow.querySelector('.discount-indicator');
        if (indicator) {
          totalRow.removeChild(indicator);
        }
      }
      
      // Clear discount field
      if (discountField) {
        discountField.value = '';
      }
      
      // Hide total savings
      const totalSavings = document.getElementById('totalSavings');
      if (totalSavings) {
        totalSavings.style.display = 'none';
      }
      
      // Remove discount badges from cart items
      const discountBadges = document.querySelectorAll('.slide-cart__item-discount-badge');
      discountBadges.forEach(badge => {
        badge.remove();
      });
      
// Re-enable all remove buttons
      const removeButtons = document.querySelectorAll('.slide-cart__remove-discount, .slide-cart__remove-discount-inline');
      removeButtons.forEach(button => {
        button.disabled = false;
      });
    }
    
    // Enhanced - Update cart display
    function updateCartDisplay(cart) {
      // Empty cart or not
      if (cart.item_count === 0) {
        if (emptyCartMessage) emptyCartMessage.style.display = 'flex';
        if (cartItemsContainer) cartItemsContainer.innerHTML = '';
        if (cartFooter) cartFooter.style.display = 'none';
        if (checkoutButton) checkoutButton.disabled = true;
        return;
      } else {
        if (emptyCartMessage) emptyCartMessage.style.display = 'none';
        if (cartFooter) cartFooter.style.display = 'block';
      }
      
      // Update cart items
      updateCartItems(cart);
      
      // Update summary with enhanced discount display
      updateCartSummary(cart);
      
      // Update shipping message
      updateShippingMessage(cart);
      
      // Check minimum order
      checkMinimumOrder(cart);
    }
    
    // Update cart items display with discount badges
    function updateCartItems(cart) {
      if (!cartItemsContainer) return;
      
      let itemsHTML = '';
      
      cart.items.forEach(item => {
        const originalLinePrice = item.original_line_price;
        const finalLinePrice = item.final_line_price;
        const hasDiscount = originalLinePrice > finalLinePrice;
        const discountPercentage = hasDiscount ? Math.round(((originalLinePrice - finalLinePrice) / originalLinePrice) * 100) : 0;
        
        // Add a discount badge for items with discounts
        const discountBadge = hasDiscount ? 
          `<div class="slide-cart__item-discount-badge">${discountPercentage}% OFF</div>` : '';
        
        itemsHTML += `
          <div class="slide-cart__item" data-key="${item.key}">
            <div class="slide-cart__item-image">
              <img src="${item.image || 'https://via.placeholder.com/70'}" alt="${item.title}">
            </div>
            <div class="slide-cart__item-details">
              <a href="${item.url}" class="slide-cart__item-title">${item.product_title}</a>
              ${item.variant_title ? `<div class="slide-cart__item-variant">${item.variant_title}</div>` : ''}
              <div class="slide-cart__item-price">
                ${discountBadge}
                ${hasDiscount ? `<span class="slide-cart__item-original-price">${formatMoney(originalLinePrice)}</span>` : ''}
                <span class="slide-cart__item-current-price">${formatMoney(finalLinePrice)}</span>
              </div>
              <div class="slide-cart__item-per-unit">${formatMoney(item.final_price)} each</div>
              <div class="slide-cart__quantity">
                <button type="button" class="slide-cart__quantity-btn minus" data-key="${item.key}">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                  </svg>
                </button>
                <div class="slide-cart__quantity-num">${item.quantity}</div>
                <button type="button" class="slide-cart__quantity-btn plus" data-key="${item.key}">
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="12" y1="5" x2="12" y2="19"></line>
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                  </svg>
                </button>
              </div>
            </div>
            <button type="button" class="slide-cart__item-remove" data-key="${item.key}">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
          </div>
        `;
      });
      
      cartItemsContainer.innerHTML = itemsHTML;
      
      // Add event listeners to new buttons
      cartItemsContainer.querySelectorAll('.slide-cart__quantity-btn.minus').forEach(button => {
        button.addEventListener('click', function() {
          const key = this.getAttribute('data-key');
          const itemContainer = this.closest('.slide-cart__item');
          const quantityDisplay = itemContainer.querySelector('.slide-cart__quantity-num');
          const currentQuantity = parseInt(quantityDisplay.textContent);
          
          if (currentQuantity === 1) {
            // If quantity is 1, remove the item
            updateCartItem(key, 0);
          } else {
            // Otherwise decrement
            quantityDisplay.textContent = currentQuantity - 1;
            updateCartItem(key, currentQuantity - 1);
          }
        });
      });
      
      cartItemsContainer.querySelectorAll('.slide-cart__quantity-btn.plus').forEach(button => {
        button.addEventListener('click', function() {
          const key = this.getAttribute('data-key');
          const itemContainer = this.closest('.slide-cart__item');
          const quantityDisplay = itemContainer.querySelector('.slide-cart__quantity-num');
          const currentQuantity = parseInt(quantityDisplay.textContent);
          
          // Update quantity immediately for better UX
          quantityDisplay.textContent = currentQuantity + 1;
          updateCartItem(key, currentQuantity + 1);
        });
      });
      
      cartItemsContainer.querySelectorAll('.slide-cart__item-remove').forEach(button => {
        button.addEventListener('click', function() {
          const key = this.getAttribute('data-key');
          const itemContainer = this.closest('.slide-cart__item');
          
          // Animate removal
          itemContainer.classList.add('removing');
          
          // Delay actual removal to allow animation to play
          setTimeout(() => {
            updateCartItem(key, 0);
          }, 300);
        });
      });
    }
    
    // Enhanced - Update cart summary
    function updateCartSummary(cart) {
      console.log('Updating cart summary:', cart);
      console.log('Discount amount:', cart.total_discounts);
      console.log('Original price:', cart.original_total_price);
      
      // Update total
      if (cartTotal) {
        cartTotal.textContent = formatMoney(cart.total_price);
      }
      
      // Update discount information if there's a discount
      if (cart.total_discounts > 0) {
        console.log('Processing discount display');
        
        // Explicitly force all discount displays to update
        forceUpdateDiscountDisplay(cart);
      } else {
        console.log('No discount to display');
        
        // Hide all discount elements
        resetDiscountUI();
      }
      
      // Update cart item count in header
      const cartItemCount = document.getElementById('cart-item-count');
      if (cartItemCount) {
        const itemsText = cart.item_count === 1 ? 'item' : 'items';
        cartItemCount.textContent = `(${cart.item_count} ${itemsText})`;
      }
    }
    
    // Update shipping message
    function updateShippingMessage(cart) {
      if (!freeShippingText || !shippingProgress) return;
      
      if (cart.total_price >= FREE_SHIPPING_THRESHOLD) {
        freeShippingText.innerHTML = `
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#C20552" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
            <polyline points="22 4 12 14.01 9 11.01"></polyline>
          </svg>
          <strong>Free shipping!</strong> Your order qualifies
        `;
        shippingProgress.classList.add('free');
      } else {
        const amountAwayFromFreeShipping = FREE_SHIPPING_THRESHOLD - cart.total_price;
        freeShippingText.innerHTML = `
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M5 12.55a11 11 0 0 1 14.08 0"></path>
            <path d="M1.42 9a16 16 0 0 1 21.16 0"></path>
            <path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path>
            <line x1="12" y1="20" x2="12.01" y2="20"></line>
          </svg>
          Add <strong>${formatMoney(amountAwayFromFreeShipping)}</strong> more for free shipping
        `;
        shippingProgress.classList.remove('free');
      }
    }
    
    // Check minimum order
    function checkMinimumOrder(cart) {
      if (!minOrderBanner || !checkoutButton || !minOrderText) return;
      
      if (cart.total_price < MIN_ORDER_AMOUNT) {
        minOrderBanner.style.display = 'flex';
        
        const amountNeeded = MIN_ORDER_AMOUNT - cart.total_price;
        minOrderText.innerHTML = 
          `Minimum order ${formatMoney(MIN_ORDER_AMOUNT)}. Add <strong>${formatMoney(amountNeeded)}</strong> more to checkout.`;
        
        checkoutButton.disabled = true;
      } else {
        minOrderBanner.style.display = 'none';
        checkoutButton.disabled = false;
      }
    }
    
    // Update cart count in header
    function updateCartCount(count) {
      const cartCountBubble = document.querySelector('.cart-count-bubble');
      
      if (!cartCountBubble) return;
      
      if (count > 0) {
        const cartCountText = cartCountBubble.querySelector('span[aria-hidden="true"]');
        if (cartCountText) {
          cartCountText.textContent = count;
        }
        
        cartCountBubble.style.display = '';
      } else {
        cartCountBubble.style.display = 'none';
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
